module.exports = __webpack_public_path__ + "img/u1633.41863abb.png";